export const SKILLS = "SKILLS";
export const SKILLS_IS_LOADING = "SKILLS_IS_LOADING";
export const SKILLS_ERROR = "SKILLS_ERROR";
